import { Skeleton } from '../ui/skeleton';

export function Loading() {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="w-full max-w-3xl space-y-4 p-4">
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-12 w-3/4" />
                <Skeleton className="h-12 w-5/6" />
            </div>
        </div>
    );
}

export function PageLoading() {
    return (
        <div className="flex min-h-screen items-center justify-center">
            <div className="w-full max-w-3xl space-y-4 p-4">
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-12 w-3/4" />
                <Skeleton className="h-12 w-5/6" />
            </div>
        </div>
    );
}
